import style from 'styled-components';

export default style.span`
  white-space: pre-wrap;
`;